export default {
  /**
   *
   * @param state
   * @returns {function(*): *}
   */
  getSubCategoryByCategory: state => (categoryId) => {
    if (state.subCategories[categoryId]) {
      return state.subCategories[categoryId];
    }

    return [];
  },

  /**
   *
   * @param state
   * @returns {function(*): *}
   */
  getMicroCategoryBySubCategory: state => (subCategoryId) => {
    if (state.microCategories[subCategoryId]) {
      return state.microCategories[subCategoryId];
    }

    return [];
  },

  /**
   *
   * @param state
   * @returns {{label: *, value: *}[]}
   */
  getCategoryForSelect: state => state.categories.map(category => ({
    value: category.id,
    label: category.name,
  })),

  /**
   *
   * @param state
   * @returns {function(*): *}
   */
  getSubCategoryForSelect: state => (categoryId) => {
    if (state.subCategories[categoryId]) {
      return state.subCategories[categoryId].map(subCategory => ({
        value: subCategory.id,
        label: subCategory.name,
      }));
    }
  },

  /**
   *
   * @param state
   * @returns {function(...[*]=)}
   */
  getMicroCategoryForSelect: state => (subCategoryId) => {
    if (state.microCategories[subCategoryId]) {
      return state.microCategories[subCategoryId].map(microCategory => ({
        value: microCategory.id,
        label: microCategory.name,
      }));
    }
  },

  /**
   *
   * * @param state
   * @returns {boolean}
   */
  getHomePageFeatureCount: (state) => {
    let count = 0;
    state.categories.forEach((item) => {
      if (item.homepage_feature) {
        count += 1;
      }
    });

    return count;
  },
};
